import SchoolIcon from '@mui/icons-material/School';
import PsychologyIcon from '@mui/icons-material/Psychology';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import * as React from 'react'

export default { SchoolIcon, PsychologyIcon, LocalHospitalIcon, React }